export const DATASTORE_ENTITY_TYPE = "datastore";
